import { api } from './api';
import { UserLookupDto } from '@/shared/types/api';

/**
 * SC-423: user names for pickers, open to every signed-in user (the admin user list is not).
 * `activeOnly` for the Assign to User modal; everyone, deactivated included, for the feed filter.
 */
export const userLookupApi = {
  list: async (activeOnly: boolean): Promise<UserLookupDto[]> =>
    (await api.get<UserLookupDto[]>('/users/lookup', { params: { activeOnly } })).data,
};
